import {api} from './api';
import {SHARE_KEY_HEADER_NAME} from '../common/sharedView';
import {RepositoryByIdResponse} from '../types';
import {GetRepositoryEntriesResponseDto} from './repositoryEntries';
import {TimelineRecordMetaDto} from './timelineRecordMeta';

export type SharedRepositorySourceDto = RepositoryByIdResponse & {
	entries: GetRepositoryEntriesResponseDto;
};

export type SharedCollectionResponseDto = SharedRepositorySourceDto & {
	/** Entry positions on the collection's timeline view. */
	meta: TimelineRecordMetaDto[];
};

export type SharedCollectionEntryResponseDto = RepositoryByIdResponse & {
	entry: GetRepositoryEntriesResponseDto;
};

/** Read-only collection behind a share link, authorized by the share key alone. */
export const sharedCollectionsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSharedCollection: builder.query<SharedCollectionResponseDto, {
			shareKey: string;
			includeArchived: boolean;
			dataFilter?: string;
			sortDir?: 'asc' | 'desc';
		}>({
			query: ({shareKey, ...params}) => ({
				url: 'shared/collection',
				params: Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== '')),
				headers: {[SHARE_KEY_HEADER_NAME]: shareKey},
			}),
			extraOptions: {maxRetries: 0},
		}),
		getSharedCollectionEntry: builder.query<SharedCollectionEntryResponseDto, {shareKey: string; entryId: string}>({
			query: ({shareKey, entryId}) => ({
				url: `shared/collection/entries/${entryId}`,
				headers: {[SHARE_KEY_HEADER_NAME]: shareKey},
			}),
			extraOptions: {maxRetries: 0},
		}),
	}),
});

export const {
	useGetSharedCollectionQuery,
	useGetSharedCollectionEntryQuery,
} = sharedCollectionsApi;
